import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { Add, DeleteForever, Edit } from '@material-ui/icons';
import ReactTable from 'react-table';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  tableWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
  },
  tableHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '85%',
    maxWidth: '1520px',
  },
  tableContainer: {
    width: '85%',
    maxWidth: '1520px',
    overflowY: 'auto',
    border: '1px solid #ddd',
  },
  table: {
    height: '400px',
  },
  addButton: {
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

const DefinizioneColonneTable = ({
  deleteRow,
  handleColumnChange,
  handleNewRow,
  loading,
  openNewValueModal,
  scheda,
}) => {
  const classes = useStyles();

  const definizioneColonneColumns = [
    {
      Header: 'Tipo di Colonna',
      id: 'tipo',
      width: 420,
      accessor: (d) => d.tipo,
      Cell: (props) => (
        <Select
          value={props.row.tipo}
          onChange={(event) =>
            handleColumnChange(event.target.value, 'tipo', props.row._index)
          }
          style={{ marginTop: 10, width: '80%' }}
        >
          <MenuItem value="testo_libero">Testo libero</MenuItem>
          <MenuItem value="selezione">Scelta Multipla</MenuItem>
          <MenuItem value="conformita">Conformità / Non Conformità</MenuItem>
          <MenuItem value="data">Data</MenuItem>
          <MenuItem value="selezione_multipla">Scelta Singola</MenuItem>
          <MenuItem value="numerico">Numerico</MenuItem>
        </Select>
      ),
    },
    {
      Header: 'Aggiungi Valore',
      id: 'aggiungiValore',
      width: 270,
      accessor: (d) => d,
      Cell: (props) => (
        <IconButton
          disabled={
            props.row.tipo !== 'selezione' &&
            props.row.tipo !== 'conformita' &&
            props.row.tipo !== 'selezione_multipla'
          }
          size="small"
          style={{ marginTop: 10 }}
          onClick={() => openNewValueModal(props.row._index)}
          title="Aggiungi valore"
        >
          <Edit />
        </IconButton>
      ),
    },
    {
      Header: 'Titolo Colonna',
      id: 'nomeColonna',
      width: 630,
      accessor: (d) => d.nomeColonna,
      Cell: (props) => {
        const [localValue, setLocalValue] = useState(
          props.row.nomeColonna || '',
        );

        return (
          <TextField
            inputProps={{
              'aria-label': 'Titolo colonna',
              style: { textAlign: 'center' },
            }}
            defaultValue={localValue}
            onChange={(event) => setLocalValue(event.target.value)}
            onBlur={() =>
              handleColumnChange(localValue, 'nomeColonna', props.row._index)
            }
            style={{ marginTop: 10, width: '80%' }}
          />
        );
      },
    },
    {
      Header: 'Elimina',
      id: 'elimina',
      width: 180,
      accessor: (d) => d,
      Cell: (props) => (
        <IconButton onClick={() => deleteRow(props.row._index)}>
          <DeleteForever color="primary" />
        </IconButton>
      ),
    },
  ];

  return (
    <div className={classes.tableWrapper}>
      <div className={classes.tableHeader}>
        <Typography variant="h5">Colonne della scheda</Typography>

        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={handleNewRow}
          title="Aggiungi colonna"
          disabled={loading}
          className={classes.addButton}
        >
          Colonna
        </Button>
      </div>

      <div className={classes.tableContainer}>
        <ReactTable
          filterable={false}
          sortable={false}
          resizable={true}
          enableEditing={true}
          showPagination={false}
          defaultPageSize={20}
          loading={loading}
          loadingText="Caricamento..."
          className={classes.table}
          data={scheda[0].definizioniColonne || []}
          columns={definizioneColonneColumns}
          noDataText="Nessun record"
        />
      </div>
    </div>
  );
};

DefinizioneColonneTable.propTypes = {
  deleteRow: PropTypes.func.isRequired,
  handleColumnChange: PropTypes.func.isRequired,
  handleNewRow: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  openNewValueModal: PropTypes.func.isRequired,
  scheda: PropTypes.array.isRequired,
};

export default DefinizioneColonneTable;
